import { NgModule } from '@angular/core';
import { TranslatePipe } from '@core/translation/translate.pipe';
import { UnitTypesFieldPipe } from '@core/translation/unit-types-field.pipe';

@NgModule({
    declarations: [TranslatePipe, UnitTypesFieldPipe],
    exports: [TranslatePipe, UnitTypesFieldPipe],
})
export class TranslationModule {}
